var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaxCoursorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.704,
    height: 19.955,
    viewBox: "0 0 12.704 19.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27498",
    "data-name": "Path 27498",
    d: "M43.518,19.978l-2.676-7.212L38.3,14.081a1.042,1.042,0,0,1-1.134-.091,1.133,1.133,0,0,1-.5-1.089l1.5-11.747A1.224,1.224,0,0,1,38.98.112a1.134,1.134,0,0,1,1.27.272L49,8.1a1.134,1.134,0,0,1,.317,1.134,1.089,1.089,0,0,1-.816.816l-2.721.771,2.676,7.212ZM41.84,10.226l2.721,7.393,1.587-.635L43.38,9.591l3.492-.952L39.842,2.38l-1.225,9.48Z",
    transform: "translate(-36.659 -0.023)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxCoursorIcon);
export default __webpack_public_path__ + "static/media/MaxCoursorIcon.1c7a2a9a1ba396a5d12b0692c40c14dc.svg";
export { ForwardRef as ReactComponent };